import {useContext} from 'react'

import Context from '@s-ui/react-context'
const BASE_CLASS = 'mt-VehicleAppraiserPage-listHowWeDoIt'
const title = 'LANDING_VEHICLE_APPRAISER.HOW_WE_CALCULATE_IT.VARIANT.TITLE'

const itemLiterals = [
  'LANDING_VEHICLE_APPRAISER.HOW_WE_CALCULATE_IT.VARIANT.WE_DISCARD_INCORRECT_VALUES',
  'LANDING_VEHICLE_APPRAISER.HOW_WE_CALCULATE_IT.VARIANT.WE_OBTAIN_THE_AVERAGE_VALUE',
  'LANDING_VEHICLE_APPRAISER.HOW_WE_CALCULATE_IT.VARIANT.WE_SELECT_THE_SAME_CARS',
  'LANDING_VEHICLE_APPRAISER.HOW_WE_CALCULATE_IT.VARIANT.WE_SHOW_MORE_THAN_600K_ADS'
]
const commonLiteralsProps = {
  highlightStart: '<strong>',
  highlightEnd: '</strong>'
}

const ListHowWeDoIt = () => {
  const {i18n} = useContext(Context)

  return (
    <div className={BASE_CLASS}>
      <h2 className={`${BASE_CLASS}-title`}>{i18n.t(title)}</h2>
      <ul className={`${BASE_CLASS}-list`}>
        {itemLiterals.map((literal, index) => (
          <li key={literal} className={`${BASE_CLASS}-listItem`}>
            <span className={`${BASE_CLASS}-listItemNumber`}>{index + 1}</span>
            <p
              className={`${BASE_CLASS}-listItemText`}
              dangerouslySetInnerHTML={{__html: i18n.t(literal, commonLiteralsProps)}}
            />
          </li>
        ))}
      </ul>
    </div>
  )
}

ListHowWeDoIt.displayName = 'ListHowWeDoIt'

export default ListHowWeDoIt
